import {createI18n} from 'vue-i18n';
import {mergeLocaleMessages, messagesFromGlob} from '../../../../i18n-glob.js';

export const supportedLanguages = ['de_be', 'en_gb', 'fr_be', 'mr_in', 'nl_be'];

const europeDateFormat = {
  longSeconds: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  },
  long: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  short: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  },
};

const datetimeFormats = {
  'fr-BE': europeDateFormat,
  'nl-BE': europeDateFormat,
  'de-BE': europeDateFormat,
  'en-GB': europeDateFormat,
};

const numberFormats = {
  'en-GB': {
    useGrouping: true,
    price: {
      style: 'currency',
      currency: 'EUR',
    },
    priceWithoutDecimal: {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    },
    decimal0Digits: {
      type: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    decimal1Digits: {
      type: 'decimal',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    },
    decimal2Digits: {
      type: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    decimal3Digits: {
      type: 'decimal',
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    },
    decimal4Digits: {
      type: 'decimal',
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    },
  },
  'fr-BE': {
    useGrouping: true,
    price: {
      style: 'currency',
      currency: 'EUR',
    },
    priceWithoutDecimal: {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    },
    decimal0Digits: {
      type: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    decimal1Digits: {
      type: 'decimal',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    },
    decimal2Digits: {
      type: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    decimal3Digits: {
      type: 'decimal',
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    },
    decimal4Digits: {
      type: 'decimal',
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    },
  },
  'de-BE': {
    useGrouping: true,
    price: {
      style: 'currency',
      currency: 'EUR',
    },
    priceWithoutDecimal: {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    },
    decimal0Digits: {
      type: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    decimal1Digits: {
      type: 'decimal',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    },
    decimal2Digits: {
      type: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    decimal3Digits: {
      type: 'decimal',
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    },
    decimal4Digits: {
      type: 'decimal',
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    },
  },
  'nl-BE': {
    useGrouping: true,
    price: {
      style: 'currency',
      currency: 'EUR',
    },
    priceWithoutDecimal: {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    },
    decimal0Digits: {
      type: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    decimal1Digits: {
      type: 'decimal',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    },
    decimal2Digits: {
      type: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    decimal3Digits: {
      type: 'decimal',
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    },
    decimal4Digits: {
      type: 'decimal',
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    },
  },
};

function loadLocaleMessages() {
  const messages = messagesFromGlob(
    import.meta.glob('../locales/**/*.json', {eager: true}),
  );

  mergeLocaleMessages(
    messages,
    loadComponentsLocaleMessages(),
    loadBaseLocaleMessages(),
    loadPluginsLocaleMessages(),
  );

  return messages;
}

function loadComponentsLocaleMessages() {
  return messagesFromGlob(
    import.meta.glob('../../../hit-components/src/locales/**/*.json', {
      eager: true,
    }),
  );
}

function loadBaseLocaleMessages() {
  return messagesFromGlob(
    import.meta.glob('../../../hit-base/src/locales/**/*.json', {
      eager: true,
    }),
  );
}

function loadPluginsLocaleMessages() {
  return messagesFromGlob(
    import.meta.glob('../../../plugins/*/locales/*.json', {
      eager: true,
    }),
  );
}

//TODO clean
let i18n;
export const initI18N = (locale) => {
  i18n = createI18n({
    legacy: false,
    locale: locale,
    fallbackLocale: {
      fr: ['fr-BE'],
      de: ['de-BE'],
      nl: ['nl-BE'],
      en: ['en-GB'],
      default: ['en-GB'],
    },
    numberFormats: numberFormats,
    datetimeFormats: datetimeFormats,
    messages: loadLocaleMessages(),
    missingWarn: false,
    fallbackWarn: false,
    warnHtmlMessage: false,
  });
  return i18n;
};

export const translate = (key) => {
  if (!key) {
    return '';
  }
  return i18n.global.t(key);
};

export const translatec = (key) => {
  if (!key) {
    return '';
  }
  return i18n.global.tc(key);
};

export default function installVueI18N(app) {
  app.use(i18n);
}
